import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Tile} from "../../Tile";
import {interval, Subscription} from "rxjs";
import {DigitalInDescription, DInDescription} from "../digitalInDescription";
import {DigitalInStatus, DIState} from "../digitalInStatus";
import {DigitalInDescriptionDataservice} from "../digitalin-description-dataservice";
import {DigitalInStatusDataservice} from "../digitalin-status-dataservice";
import {DigitalindetailsComponent} from "../digitalindetails/digitalindetails.component";
import {environment} from "../../../environments/environment";


@Component({
  selector: 'app-dgitalinlist',
  templateUrl: './digitalinlist.component.html',
  styleUrls: ['./digitalinlist.component.css']
})
export class DigitalinlistComponent implements OnInit, OnDestroy {
  tiles: Tile[] = [
    {text: 'Tile 1', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double purple'},
    {text: 'Tile 2', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double red'},
    {text: 'Tile 3', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double skyblue'},
    {text: 'Tile 4', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double yellow'},
  ];

  @Input()
  dInDescription: DigitalInDescription | undefined;
  dInStatus: DigitalInStatus | undefined;
  private updateSubscription: Subscription | undefined;
  errorMessage: string = "";
  componentList = Array<DigitalindetailsComponent>();
  public loaderStatus: number = 0;
  tabstripWidth: string = "1";

  constructor(private digitalinDescriptionDataservice: DigitalInDescriptionDataservice,
              private digitalinStatusDataservice: DigitalInStatusDataservice           )  {
  }

  InitLayout(): void {
    this.digitalinDescriptionDataservice.GetData().subscribe({
      next: dInDescription => {
        this.dInDescription = dInDescription;
        this.componentList.forEach((detail => {
          console.log('Node update');
          detail.UpdateLayoutData(this.GetDescription(detail.refNumber));
        }))
      },
      error: err => this.errorMessage = err
    });
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.digitalinStatusDataservice.GetData().subscribe(
      {
        next: dInStatus => {
          this.loaderStatus = 1;
          this.dInStatus = dInStatus;
          this.componentList.forEach((detail => {
            detail.UpdateDiState(this.GetStatus(detail.refNumber));
          }));
          this.ReSubscribe();
        }, error: err => this.errorMessage = err
      });
  }


  ngOnInit(): void {
    this.InitLayout();
    this.UpdateData();


  }
  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }


  Add(digitalinDetail: DigitalindetailsComponent): void
  {
    this.componentList.push(digitalinDetail);
  }

  GetDescription(refNumber: number): DInDescription {
    if( ( this.dInDescription) && (this.dInDescription.DI[refNumber]))
      return this.dInDescription.DI[refNumber];
    return new DInDescription();
  }

   GetStatus(refNumber: number): DIState {
    if( ( this.dInStatus) && (this.dInStatus.DI[refNumber]))
      return this.dInStatus.DI[refNumber];
    return new DIState();
  }
}
